module.exports = __webpack_public_path__ + "static/media/KAPorg-logo.8d3a604d.svg";